import { PreautorisationSelectors } from '../../state/preautorisation.selectors';
import { StepEnum } from '../../constants/step.enum';
import { TypeProjet } from '../../../../shared/constants/type-projet.enum';
import { TypeEmprunteurEnum } from '../../constants/type-emprunteur.enum';

export interface StepConfig {
  step: StepEnum;
  conditions?: () => (state: any, ...states: any[]) => boolean; // wrappé dans une fonction pour éviter les erreurs dans l'ordre d'import
}

export const STEPS_CONFIG: Array<StepConfig> = [
  {
    step: StepEnum.ETAPE_ACCEPTER_PROJET,
    conditions: () => PreautorisationSelectors.isEmprunteurSecondaire
  },
  {
    step: StepEnum.ETAPE_TYPE_PROPRIETE,
    conditions: () => PreautorisationSelectors.isEmprunteurPrincipal
  },
  {
    step: StepEnum.AIGUILLEUR_RESIDENCE_PRINCIPALE,
    conditions: () => state =>
      PreautorisationSelectors.typePreautorisation(state.preautorisationExperimente) === TypeProjet.PremierAcheteur &&
      !PreautorisationSelectors.isCoemprunteur(state.preautorisationExperimente)
  },
  {
    step: StepEnum.AIGUILLEUR_CITOYENNETE,
    conditions: () => PreautorisationSelectors.isEmprunteurPrincipal
  },
  {
    step: StepEnum.AIGUILLEUR_MULTIPROPRIETAIRE,
    conditions: () => state => {
      const type = PreautorisationSelectors.typePreautorisation(state.preautorisationExperimente);
      return type === TypeProjet.ExperimenteRemplacer || type === TypeProjet.ExperimenteSecondaire;
    }
  },
  {
    step: StepEnum.AIGUILLEUR_SALARIE
  },
  {
    step: StepEnum.ETAPE_COEMPRUNTEUR,
    conditions: () => PreautorisationSelectors.isEmprunteurPrincipal
  },
  {
    step: StepEnum.ETAPE_CONSENTEMENT
  },
  {
    step: StepEnum.ETAPE_REVENU_BRUT
  },
  {
    step: StepEnum.ETAPE_ACHAT_A_DEUX,
    conditions: () => state =>
      // Emprunteur unique -> toujours affiché
      // CO 1 => toujours affichée
      // CO 2 => affichée si isResidenceActuelleMemeCoemprunteur est false
      PreautorisationSelectors.typePreautorisation(state.preautorisationExperimente) ===
        TypeProjet.ExperimenteSecondaire &&
      (PreautorisationSelectors.isEmprunteurPrincipal(state.preautorisationExperimente) ||
        !PreautorisationSelectors.isMemeCoemprunteurProprieteActuelle(state.preautorisationExperimente))
  },
  {
    step: StepEnum.ETAPE_MEME_COEMPRUNTEUR,
    conditions: () => state =>
      // Emprunteur unique -> jamais affiché
      // CO 1 -> affiché si résidence principale achetée avec coemprunteur
      // CO 2 -> jamais affiché
      PreautorisationSelectors.typePreautorisation(state.preautorisationExperimente) ===
        TypeProjet.ExperimenteSecondaire &&
      PreautorisationSelectors.isEmprunteurPrincipal(state.preautorisationExperimente) &&
      PreautorisationSelectors.isCoemprunteur(state.preautorisationExperimente) &&
      PreautorisationSelectors.isAchatADeux(state.preautorisationExperimente)
  },
  {
    step: StepEnum.ETAPE_HYPOTHEQUE,
    conditions: () => state =>
      // Emprunteur unique -> toujours affiché
      // CO 1 => toujours affichée
      // CO 2 => affichée si isAchatMemeCoemprunteur est false
      PreautorisationSelectors.typePreautorisation(state.preautorisationExperimente) ===
        TypeProjet.ExperimenteSecondaire &&
      (PreautorisationSelectors.isEmprunteurPrincipal(state.preautorisationExperimente) ||
        !PreautorisationSelectors.isMemeCoemprunteurProprieteActuelle(state.preautorisationExperimente))
  },
  {
    step: StepEnum.ETAPE_PRIX_PROPRIETE,
    conditions: () => PreautorisationSelectors.isEmprunteurPrincipal
  },
  {
    step: StepEnum.ETAPE_REVENU_LOCATIF,
    conditions: () => state =>
      // Emprunteur unique -> toujours affiché
      // CO 1 => toujours affichée
      // CO 2 => jamais affichée
      PreautorisationSelectors.typeEmprunteur(state.preautorisationExperimente) !== TypeEmprunteurEnum.Coemprunteur2 &&
      PreautorisationSelectors.nbrLogements(state.preautorisationExperimente) > 1
  },
  {
    step: StepEnum.ETAPE_MISE_DE_FONDS,
    conditions: () => PreautorisationSelectors.isEmprunteurPrincipal
  },
  {
    step: StepEnum.ETAPE_COORDONNEES
  },
  {
    step: StepEnum.ETAPE_RECAP
  }
];
